export { default as about } from "./about";
export { default as contact } from "./contact";
export { default as notes } from "./notes";
export { default as weather } from "./weather";
export { default as calendar } from "./calendar";
export { default as profile } from "./profile";
export { default as viewNotFound } from "./viewNotFound";
